export const SAVE_PROFILE = 'SAVE_PROFILE';

export const saveProfile = (profile) => {
  return {
    type: SAVE_PROFILE,
    data: profile,
  };
};
